export { Scissors as default } from './Scissors';
